<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex text-xs-center>
        <v-card class="elevation-5" v-if="!alertShow" max-width="1000">
          <v-card-text>
            <div class="headline">{{ reportTitle }}</div>
          </v-card-text>
          <v-col cols="12">
            <div class="headline1 mr-10">{{ reportFilter }}</div>
            <v-row>
              <v-col cols="6">
                <v-combobox v-model="startWeek" :items="client_calendar" item-text="week_display" label="Start Week" outlined dense clearable :loading="calendarloading" :rules="startWeekRules"></v-combobox>
              </v-col>
              <v-col cols="6">
                <v-combobox v-model="endWeek" :items="client_calendar" item-text="week_display" label="End Week" outlined dense clearable :loading="calendarloading" :rules="endWeekRules"></v-combobox>
              </v-col>
            </v-row>
            <div class="headline1 mr-10">Or specify a custom date range:</div>
            <v-row no-gutters class="mx-4">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Start Date"
                    prepend-icon="event"
                    v-bind="attrs"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                    readonly=""
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
              </v-menu>
              <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted2"
                    label="End Date"
                    prepend-icon="event"
                    v-bind="attrs"
                    @blur="endDate = parseDate(dateFormatted2)"
                    v-on="on"
                    readonly=""
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-row>
            <v-row>
              <v-col>
                <v-btn :loading="loading" @click="generateReport" class="mt-2 ml-3" dark color="purple darken-4">Generate Report</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
        <div>
          <v-alert v-model="alertShow" text dismissible dense outlined :color="alertColor" icon="mdi-clock-fast" border="left">{{ alertMessage }} </v-alert>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from "moment";
import axios from "axios";
import config from "../config";

export default {
  data: (vm) => ({
    startWeek: null,
    endWeek: null,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    endDate: new Date().toISOString().substr(0, 10),
    dateFormatted2: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    loading: false,
    alertShow: false,
    alertColor: "blue",
    alertMessage: "",
    reportTitle: "",
    reportFilter: "",
    baseUrl: "",
    calendarloading: false
  }),

  beforeRouteUpdate(to, from, next) {
    this.getContent(to.params.reportName);
    next();
  },

  created() {
    this.getContent(this.$route.params.reportName);
  },
  computed: {
    startWeekRules()
    {
      return [
        (sw) =>
        {
          if (sw && this.endWeek && sw.start_date > this.endWeek.start_date)
          {
            return "Start week must be before end week"
          }
          return true
        }]
    },
    endWeekRules()
    {
      return [
        (ew) =>
        {
          if (ew && this.startWeek && ew.start_date < this.startWeek.start_date)
          {
            return "End week must be after start week"
          }
          return true
        }]
    }
  },
  asyncComputed: {
    client_calendar: {
      // lazy: true,
      async get() {
        try {
          this.calendarloading = true
          let response = await axios.get(config.QDS + `calendars/${this.getClientId()}`, { headers: { Authorization: this.$store.state.auth.idToken } })
          return response.data
        } catch (e) {
          console.error(e);
          return [];
        } finally {
          this.calendarloading = false
        }
      },
      default: []
    }
  },
  watch: {
    date(val, oldVal) {
      if (val > this.endDate) {
        this.date = oldVal;
        this.dateFormatted = this.formatDate(oldVal);
      } else {
        this.dateFormatted = this.formatDate(val);
      }
    },
    endDate(val, oldVal) {
      if (val < this.date) {
        this.endDate = oldVal;
        this.dateFormatted2 = this.formatDate(oldVal);
      } else {
        this.dateFormatted2 = this.formatDate(val);
      }
    },
    startWeek(val, oldVal)
    {
      if (!this.endWeek) this.endWeek = val
    }
  },

  methods: {
    getContent(reportName) {
      switch (reportName) {
        case "partDetails":
          this.reportTitle = "Parts Detail Report";
          this.reportFilter = "Branch Date Filter";
          this.baseUrl = "partdetail";
          break;
        case "branchCompliance":
          this.reportTitle = "Cataloging - Branch Compliance";
          this.reportFilter = "Reporting Week Filter";
          this.baseUrl = "branchcompliance";
          break;
        case "testingDetail":
          this.reportTitle = "Testing Detail Report";
          this.reportFilter = "Reporting Week Filter";
          this.baseUrl = "testingdetail";
          break;
        case "warrantyReturnValuation":
          this.reportTitle = "Warranty Return Valuation Report";
          this.reportFilter = "Reporting Week Filter";
          this.baseUrl = "warrantyreturnvaluation";
          break;
        case "warrantyReturnPartQueue":
          this.reportTitle = "Warranty Return Part Queue";
          this.reportFilter = "Reporting Week Filter";
          this.baseUrl = "warrantyreturnpartqueue";
          break;
        case "shippingPerformance":
          this.reportTitle = "Shipping Performance (for large date range)";
          this.reportFilter = "Ship Date Week Filter";
          this.baseUrl = "shipping_performance";
          break;
        case "auditObservations":
          this.reportTitle = "Audit Observations";
          this.reportFilter = "Reporting Week Filter";
          this.baseUrl = "auditobservations";
          break;
        case "cdrPipeline":
          this.reportTitle = "CDR Pipeline";
          this.reportFilter = "Reporting Week Filter";
          this.baseUrl = "cdrpipeline";
          break;
        
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    async generateReport() {
      this.loading = true;

      let from, to
      if (this.startWeek) // week picker has precedence if in use
      {
        from = moment(this.startWeek.start_date).startOf("day").format("YYYY/MM/DD HH:mm:ss")
        to = moment(this.endWeek.end_date).endOf("day").format("YYYY/MM/DD HH:mm:ss")
      }
      else
      {
        from = moment(this.date).startOf("day").format("YYYY/MM/DD HH:mm:ss")
        to = moment(this.endDate).endOf("day").format("YYYY/MM/DD HH:mm:ss")
      }
      var clientId = this.getClientId();
      var returnData;

      // All custom reports now use QBOS_Report
      const qbosReports = {
        "testingdetail": "rev/testingdetail/query",
        "branchcompliance": "rev/branchcompliance/query",
        "partdetail": "rev/partdetail/query",
        "warrantyreturnvaluation": "rev/warrantyreturnvaluation/query",
        "warrantyreturnpartqueue": "rev/warrantyreturnpartqueue/query",
        "shipping_performance": "fwd+rem/shipping_performance/query",
        "cdrpipeline": "rev/cdrpipeline/query",
        "auditobservations": "fwd+rem/auditobservations/query"
      };

      if (!qbosReports[this.baseUrl])
      {
        throw new Error(`Unknown report: ${this.baseUrl}`);
      }

      const userEmail = this.$store.state.auth.profile.email;

      returnData = await axios.put(
        config.QBOS + "report",
        {
          mode: "ASYNC",
          client_id: clientId,
          email_recipients: [userEmail],
          report_name: this.reportTitle,
          reports: [{
            report_path: qbosReports[this.baseUrl],
            filename: this.reportTitle,
            extension: "csv",
            parameters: {
              client_id: clientId,
              start_date: from,
              end_date: to
            }
          }]
        },
        {
          params: { Authorization: `Bearer ${this.$store.state.auth.idToken}` }
        }
      )

      this.showMessage(returnData.status);
    },

    getClientId() {
      let users_client_id = this.$store.state.auth.profile["custom:client_id"];
      let client_id;

      if (users_client_id == "999" && this.$store.state.portalsettings.client) {
        // qgistix user w/999, and there is a client in the app setting, we use it
        client_id = String(this.$store.state.portalsettings.client.client_id);
      } // no selected client for QGistix 999 user, or a client who can only be their own client_id
      else {
        client_id = users_client_id;
      }
      return client_id;
    },

    showMessage(status) {
      var local = this;
      this.loading = false;
      var emailAddreess = this.$store.state.auth.profile.email;

      var msg = `Your report is processing, an email with a link to download the report will be sent to ` + emailAddreess + ` upon completion.`;
      var errorMsg = "An error occured whild processing your report. Please try again.";

      if (status >= 200 && status < 300) {
        this.alertMessage = msg;
        this.alertColor = "blue";
      } else {
        this.alertMessage = errorMsg;
        this.alertColor = "red";
      }

      this.alertShow = true;
      setTimeout(function() {
        local.alertShow = false;
      }, 9000);
    },
  },
};
</script>
